import React from 'react';
import PropTypes from 'prop-types';

export default class MapTooltip extends React.Component {
  constructor(props) {
    super(props);
    this.renderTiers = this.renderTiers.bind(this);
    this.state = {
      tooltipStyle: {
        position: 'absolute',
      },
    };
  }

  componentDidUpdate(prevProps) {
    if (!this.state.tooltipStyle.left || prevProps.tooltipRegion !== this.props.tooltipRegion) {
      this.updateHelper();
    }
  }

  updateHelper() {
    if (this.props.tooltipLeftOffset) {
      const tooltipHeight = this.mapTooltipNode.offsetHeight;
      const tooltipWidth = this.mapTooltipNode.offsetWidth;
      let newLeft = this.props.tooltipLeftOffset;
      let newTop = this.props.tooltipTopOffset;
      const leftAdjust = Math.abs(tooltipWidth - this.props.tooltipWidthOffset) / 2;
      if (tooltipWidth > this.props.tooltipWidthOffset) {
        newLeft -= leftAdjust;
      } else {
        newLeft += leftAdjust;
      }

      // Adjust the tooltip to be 20 pixels higher than the middle of the state.
      const topAdjust = tooltipHeight - (this.props.tooltipHeightOffset / 2);
      newTop -= (topAdjust + 20);

      this.setState({
        tooltipStyle: {
          position: 'absolute',
          top: newTop,
          left: newLeft,
        },
      });
    }
  }

  renderTiers() {
    if (this.props.showToolTip) {
      return (this.props.renderTooltipTemplate(this.props));
    }

    return (<ul />);
  }

  render() {
    return (
      <div
        ref={(node) => { this.mapTooltipNode = node; }}
        className={`interactive-map-tooltip ${!this.props.showToolTip ? 'hidden' : ''}`}
        style={this.state.tooltipStyle}
        onMouseLeave={this.props.leaveTooltip}
        onMouseEnter={this.props.enterTooltip}
      >
        {this.renderTiers()}
        <div className="tooltip-triangle" />
      </div>
    );
  }
}

MapTooltip.defaultProps = {
  tooltipRegion: null,
  tooltipTopOffset: null,
  tooltipLeftOffset: null,
  tooltipWidthOffset: null,
  tooltipHeightOffset: null,
  enterTooltip: null,
  leaveTooltip: null,
};

MapTooltip.propTypes = {
  showToolTip: PropTypes.bool.isRequired,
  tooltipRegion: PropTypes.string,
  tooltipTopOffset: PropTypes.number,
  tooltipLeftOffset: PropTypes.number,
  tooltipWidthOffset: PropTypes.number,
  tooltipHeightOffset: PropTypes.number,
  enterTooltip: PropTypes.func,
  leaveTooltip: PropTypes.func,
  renderTooltipTemplate: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src-react/UsaMap/components/MapTooltip.jsx